/**
 * Knowledge Base Adapter
 * Transforms knowledge base data between API and application layer
 */

import { BaseAdapter } from './base.adapter';
import type {
  KnowledgeBase,
  KnowledgeBaseResponseDto,
} from '@/types';

export class KnowledgeBaseAdapter extends BaseAdapter {
  /**
   * Adapts knowledge base from API response
   * Handles both populated objects and string IDs for relationships
   */
  static fromApi(dto: KnowledgeBaseResponseDto): KnowledgeBase {
    // Helper to extract IDs from potentially populated fields
    const extractIds = (items: (string | { id: string })[]): string[] => {
      return items.map((item) => (typeof item === 'string' ? item : item.id));
    };

    return {
      id: dto.id,
      name: dto.name,
      description: dto.description || '',
      content: dto.content,
      mode: dto.mode,
      status: dto.status,
      accountId: dto.accountId,
      createdBy: dto.createdBy,
      intents: dto.intents || [],
      tags: dto.tags || [],
      sources: extractIds(dto.sources || []),
      instructions: extractIds(dto.instructions || []),
      enabledChannels: extractIds(dto.enabledChannels || []),
      createdAt: dto.createdAt,
      updatedAt: dto.updatedAt
    };
  }

  /**
   * Adapts knowledge bases array from API response
   */
  static fromApiList(dtos: KnowledgeBaseResponseDto[]): KnowledgeBase[] {
    return dtos.map((dto) => this.fromApi(dto));
  }
}
